// extracted by mini-css-extract-plugin
export default {"wrap":"ar-z","melodyCategory":"br-z","fullWidth":"cr-z","items":"dr-z","featureCss":"er-z","disabled":"fr-z","imgCss":"gr-z"};